<template>

  <b-row>
    <b-col>
      <b-card
        no-body
        :class="{ open: visibleBody }"
      >
        <b-card-header
          :class="{ collapsed: !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="() => visibleBody = !visibleBody"
          style="padding: 1rem;background-color: #0080C9; color: white; font:45px; padding:15px;"
        >
          <span class="lead collapse-title">
            <strong>ANAMNESIS</strong>
          </span>
          <i
            :class="
              visibleBody
                ? 'fas fa-chevron-up'
                : 'fas fa-chevron-down'
            "
          />
        </b-card-header>
        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 10px">
            <div class="col-md-12 mb-3">
              <MotivoConsulta/>
              <SemiologiasMain :esCrear="esCrear"/>
            
              <AntecedentesPersonales :optionsOdontologia = "optionsOdontologia" />              
              <AntecedentesFamiliares :idPaciente = "idPaciente"/>
              <ProblemaActual />
              <RevisionOrganosSistemas v-if="!esOdontologia"/>
              <ExamenFisico v-if="!esOdontologia"/>
              <AtencionDiagnosticos/>
              <PlanTratamiento/>
              <TipoVez/>
            </div>
          </b-card-body>

        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>

<script>
import { mapState } from 'vuex';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';

import {
  ProblemaActual, AntecedentesPersonales, 
  AntecedentesFamiliares, TipoVez
} from '@/views/citas/components';


import ExamenFisico            from '@/views/atencionCita/components/Anamnesis/ExamenFisico/ExamenFisico.vue';
import RevisionOrganosSistemas from '@/views/atencionCita/components/Anamnesis/RevisionOrganosSistemas/RevisionOrganosSistemas.vue';
import AtencionDiagnosticos    from '@/views/atencionCita/components/Diagnosticos/AtencionDiagnosticos.vue';
import SemiologiasMain         from '@/views/atencionCita/components/Anamnesis/Semiologias/SemiologiasMain.vue';
import MotivoConsulta          from "./MotivoConsulta.vue";
import PlanTratamiento         from './PlanTratamiento.vue';
import Odontograma from '../../../../citas/components/Odontograma/Odontograma.vue';
import SistemaEstomatogmatico from '../../../../citas/components/Odontologia/SistemaEstomatogmatico.vue';
import SaludBucal from '../../../../citas/components/Odontologia/SaludBucal.vue';
import IndicesCpo from '../../../../citas/components/Odontologia/IndicesCpo.vue';

export default {

  name: 'CrearAnamnesis',

  components: {
    MotivoConsulta, ExamenFisico,
    PlanTratamiento, AtencionDiagnosticos,
    ProblemaActual,
    AntecedentesPersonales, AntecedentesFamiliares,
    RevisionOrganosSistemas, TipoVez,
    SemiologiasMain, Odontograma, SistemaEstomatogmatico,
    SaludBucal, IndicesCpo
  },

  props: {

    idPaciente: {
      type: [String, Number, Boolean, Object, Array, Function],
      default: 0 // Valor por defecto si no se proporciona
    },

  },
  
  data() {
    return {
       optionsOdontologia:null,
      idpaciente: null,
      visibleBody: false,
      visibleBodyOdontograma:false,
      esCrear:true,
    };
  },
  

  computed: {
    ...mapState({
      codEsp          : state => state.atencionCita.dataCita?.doctor.especialidad.codEsp,
      stEspecialidad  : state => state.atencionCita.dataCita?.doctor.especialidad,
      stSemFisiatrica : state => state.atencionCita.semiologias?.semFisiatrica,
      stMotivoConsulta: state => state.atencionCita.anamnesis?.motivoConsulta?.tipoVez,
      stDataDoctor    : state => state.atencionCita.dataCita?.doctor,
    }),

     esOdontologia() {
      return this.stDataDoctor?.especialidad?.codEsp === '0000000134';
    },
  },

  
  methods: {
   

    resetDatos() {
      this.$store.commit("resetAnamnesis");
    },

  },
  
  watch :{
     esOdontologia:{
      deep:true,
      inmediate:true,
      handler(){
        let optionsOdontologia = [
  { "text": "ALERGIA MEDICAMENTO", "value": "alergia_medicamento" },
  { "text": "ALERGIA ANESTESIA", "value": "alergia_anestesia" },
  { "text": "HEMORRAGIAS", "value": "hemorragias" },
  { "text": "VIH/SIDA", "value": "vih_sida" },
  { "text": "TUBERCULOSIS", "value": "tuberculosis" },
  { "text": "ASMA", "value": "asma" },
  { "text": "DIABETES", "value": "diabetes" },
  { "text": "HIPERTENSIÓN", "value": "hipertension" },
  { "text": "ENF. CARDIACA", "value": "enf_cardiaca" },
 { "text": "OTROS", "value": "otros" },]
        this.optionsOdontologia = [...optionsOdontologia];
      }
    },
  }
};

</script>
